import {
    styled,
    Typography,
    Unstable_Grid2 as Grid,
    Container,
    Divider,
} from "@mui/material";
import { shouldForwardProp } from "@mui/styled-engine";
import React, { Fragment } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { hexToRgb } from "./utils";
import { useLocation } from "react-router";

const StyledHeader = styled("div", {
    shouldForwardProp: (p) =>
        !["large", "noBackgroundImage"].includes(p.toString()),
})<{ large: boolean; noBackgroundImage: boolean }>(
    ({ theme, large, noBackgroundImage }) => ({
        width: "calc(100%)",
        marginRight: "0px",
        marginTop: "-24px",
        marginLeft: "0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        overflow: "visible",
        ...(!large
            ? {
                  marginBottom: "24px",
                  //   position: "sticky",
                  //   top: 0,
                  //   left: 0,
                  //   right: 0,
              }
            : {
                  display: "flex",
              }),
        height: large ? "340px" : "140px",
        [theme.breakpoints.down("md")]: {
            height: large ? "220px" : "100px",
        },
        color:
            large || noBackgroundImage ? theme.palette.primary.main : "white",
        ".container": {
            width: "100%",
            height: "100%",
            padding: large ? "16px 0px" : 0,
            ".MuiTypography-root": {
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
            },
            ".bold": {
                fontWeight: "bold",
            },
        },
    })
);

const BackgroundImage = styled("div", {
    shouldForwardProp: (p) =>
        !["large", "noBackgroundImage"].includes(p.toString()),
})<{ large: boolean; noBackgroundImage: boolean }>(
    ({ large, noBackgroundImage, theme }) => ({
        position: "absolute",
        right: 0,
        top: 0,
        left: 0,
        bottom: 0,
        background: noBackgroundImage
            ? "none"
            : large
            ? `linear-gradient(0deg, rgba(255, 255, 255, 0.75) 40%, rgba(255, 255, 255, 0) 81.08%), url(${window.location.origin}/images/warming-stripes.png);`
            : `url(${window.location.origin}/images/internal-header.png)`,
        backgroundPosition: large ? "right top" : "right",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        boxShadow: `0px 4px 2px -2px rgba(${hexToRgb(
            theme.palette.secondary.main,
            "string"
        )}, 0.2)`,
        borderBottom: `solid 1px ${theme.palette.secondary.main}`,
    })
);

const StyledContainer = styled(Container)(() => ({
    display: "flex",
    flexFlow: "column",
    flexGrow: 1,
    marginTop: "32px",
    paddingTop: "2px",
    zIndex: 1,
}));

const Header = () => {
    const {
        headerOptions: { large, title, description },
    } = useAppSelector((state) => state.common);

    const { pathname } = useLocation();

    const noBackgroundImageRoutes: string[] = [];

    return (
        <Fragment>
            <StyledHeader
                large={large}
                noBackgroundImage={noBackgroundImageRoutes.includes(pathname)}
            >
                <BackgroundImage
                    large={large}
                    noBackgroundImage={noBackgroundImageRoutes.includes(
                        pathname
                    )}
                ></BackgroundImage>
                <StyledContainer maxWidth={false}>
                    <Grid
                        container
                        spacing={2}
                        className="container"
                        alignContent={large ? "flex-end" : "center"}
                    >
                        <Grid xs={12} sm={10} md={8}>
                            {typeof title === "string" ? (
                                <Typography
                                    variant="h2"
                                    fontSize="2.5rem !important"
                                    gutterBottom={!!description}
                                    fontWeight="bold"
                                >
                                    {title}
                                </Typography>
                            ) : (
                                title
                            )}
                            {description &&
                                (typeof description === "string" ? (
                                    <Typography
                                        variant="body1"
                                        className="description"
                                    >
                                        {description}
                                    </Typography>
                                ) : (
                                    description
                                ))}
                        </Grid>
                    </Grid>
                </StyledContainer>
            </StyledHeader>
        </Fragment>
    );
};

export default Header;
